import React, { ReactNode } from 'react';
import { SxProps, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Theme } from '@mui/material';
import type { TableSortState } from './useTableSort';
import './StyledTable.scss';

export interface StyledTableColumn {
  name: string;
  /** Column width, e.g. '25%'. Use '1%' to collapse the column to the width of its content. */
  width: string;
  sx?: SxProps<Theme>;
}

export interface StyledTableHeaderColumn extends StyledTableColumn {
  sortable: boolean;
}

export interface StyledTableProps {
  columns: StyledTableHeaderColumn[];
  children: ReactNode;
  className?: string;
  sort: TableSortState;
}

export const StyledTable: React.FC<StyledTableProps> = ({ columns, children, className = '', sort }) => {
  return (
    <TableContainer className={`psf-styled-table__container ${className}`}>
      <Table className="psf-styled-table">
        <TableHead className="psf-styled-table__header">
          <TableRow>
            {columns.map((column, index) => {
              const active = column.sortable && sort.key === column.name;

              return (
                <TableCell
                  key={`${column.name}-${index}`}
                  align="left"
                  className="psf-styled-table__header-cell"
                  sx={{ width: column.width, ...column.sx }}
                  sortDirection={active ? sort.order : false}
                >
                  {column.sortable ? (
                    <TableSortLabel
                      className="psf-styled-table__header-sort"
                      active={active}
                      direction={active ? sort.order : 'desc'}
                      onClick={() => sort.toggle(column.name)}
                    >
                      {column.name}
                    </TableSortLabel>
                  ) : (
                    column.name
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody sx={{ position: 'relative' }}>{children}</TableBody>
      </Table>
    </TableContainer>
  );
};
